import type { Action, Environment, Resource } from "@shield-acl/core";
import type { CheckOptions } from "../context";

/** Especificação de uma checagem: [action, resource?, options?]. */
export type CheckSpec = [Action, Resource?, CheckOptions?];

/** Chave estável para memoização (funções são ignoradas). */
export function stableKey(value: unknown): string {
  try {
    return JSON.stringify(value) ?? "undefined";
  } catch {
    return "unserializable";
  }
}

/** Merge raso de environments (opts sobrepõe o do Provider). */
export function mergeEnv(
  base: Environment | undefined,
  override: Environment | undefined,
): Environment | undefined {
  if (!base && !override) return undefined;
  return { ...base, ...override };
}
